<template>
    <ion-card>
        <ion-card-header>
            <ion-item lines="none" class="ion-no-margin ion-no-padding">
                <ion-card-title>{{ $t('ncrypt.subscription_page.title') }}</ion-card-title>
                <ion-badge v-if="$store.getters.hasPaidSubscription && subscription.is_active" slot="end" class="ion-color ion-color-success">{{ $t('ncrypt.active') }}</ion-badge>
                <ion-badge v-else-if="$store.getters.hasPaidSubscription" slot="end" class="ion-color ion-color-danger">{{ $t('ncrypt.inactive') }}</ion-badge>
            </ion-item>
        </ion-card-header>
        <ion-card-content v-if="subscription && $store.getters.hasPaidSubscription">
            <ion-item>
                <ion-label slot="start">{{ $t('ncrypt.name') }}</ion-label>
                <ion-text>{{ subscription.plan.name }}</ion-text>
            </ion-item>
            <ion-item>
                <ion-label slot="start">{{ $t('ncrypt.created_at') }}</ion-label>
                <ion-text>{{ subscription.created_at }}</ion-text>
            </ion-item>
            <ion-item>
                <ion-label slot="start">{{ $t('ncrypt.price') }}</ion-label>
                <ion-text>€ {{ subscription.plan.amount }} <small>per {{ subscription.plan.interval_label_short }}</small></ion-text>
            </ion-item>
            <ion-item v-if="!subscription.is_active" lines="none">
                <ion-label class="ion-color ion-color-danger ion-margin">{{ $t('ncrypt.subscription_page.not_active_contact_us') }}</ion-label>
            </ion-item>
            <br/>
            <ion-text v-if="subscription.is_active"><h2>{{ $t('ncrypt.subscription_page.included_features') }}</h2></ion-text>
            <ion-item lines="none">
                <plan-features-list :features="subscription.plan.features" v-if="subscription.is_active"/>
                <ion-button slot="end" fill="outline" color="danger" @click="cancelSubscription">{{ $t('ncrypt.subscription_page.cancel') }}</ion-button>
            </ion-item>
        </ion-card-content>
        <ion-card-content v-else>
            <h2>{{ $t('ncrypt.subscription_page.you_are_using_ncrypt_free') }}</h2>
            <br/>

            <div v-if="subscription">
                <ion-text v-if="subscription.is_active"><h2>{{ $t('ncrypt.subscription_page.included_features') }}</h2></ion-text>
                <ion-item lines="none">
                    <plan-features-list :features="subscription.plan.features" v-if="subscription.is_active"/>
                </ion-item>
            </div>

            <h3>{{ $t('ncrypt.subscription_page.upgrade_to_pro_for_extra_features') }}</h3>
            <br/>
            <ion-button @click="discoverPro">{{ $t('ncrypt.subscription_page.discover_benefits') }}</ion-button>
        </ion-card-content>
    </ion-card>
</template>

<script>
    import {MenuHandler} from "../../services/MenuHandler";
    import PlanFeaturesList from "../pro/PlanFeatureList";
    import {Notifier} from "../../services/Notifier";

    export default {
        name: "Subscription",
        components: {PlanFeaturesList},
        computed: {
            subscription() {
                return this.$store.getters.subscription;
            }
        },
        methods: {
            discoverPro() {
                MenuHandler.open('pro');
            },
            cancelSubscription() {
                Notifier.showAlert({
                    header: this.$t('ncrypt.subscription_page.cancel_subscription'),
                    message: this.$t('ncrypt.subscription_page.contact_us_to_cancel_subscription'),
                    buttons: ['OK'],
                });
            },
        },
    }
</script>
